import React, { useEffect, useState } from 'react';
import ImagePreview from './ImagePreview';
import { TruncatedText } from '../../../common';
import { formatCurrency } from '../../../../utils/global';
import OptionsContainer from './OptionsContainer';
import styles from './multiProductReview.module.css';
import AddToCartButton from './AddToCartButton';
import useIsMobile from '../../../../hooks/useIsMobile';

interface Props {
  product: any;
  productForOptions: any;
  productDetails: any;
  allOptions: any;
  defaultCurrency: string;
  maxQuantities: any;
  quantities: any;
  setQuantities: React.Dispatch<React.SetStateAction<any>>;
}

export default function MultiProductPreview({
  product,
  productForOptions,
  productDetails,
  allOptions,
  defaultCurrency,
  maxQuantities,
  quantities,
  setQuantities,
}: Props) {
  const isMobile = useIsMobile();
  const [isCartEnabled, setIsCartEnabled] = useState(false);

  const currentQuantity = quantities?.[product.variantId || product.id] || 0;
  useEffect(() => {
    if (currentQuantity > 0 && !isCartEnabled) {
      setIsCartEnabled(true);
    }
  }, [currentQuantity, isCartEnabled]);

  return (
    <div key={product.id} className={`${styles.multiProductsPreviewItem} rounded`}>
      <div className="flex flex-col items-center gap-4 flex-grow">
        <ImagePreview imageUrl={productDetails?.productImage} name={productDetails?.productName} />
        <div className={`w-full ${isMobile ? 'mt-2' : 'mt-4'}`}>
          <div className={`w-full flex flex-between ${isMobile ? 'mb-1' : 'mb-2'}`}>
            <div className={`font-medium text-default ${isMobile ? 'text-sm' : 'text-base'}`}>
              <TruncatedText text={productDetails?.productName} maxLines={1} width={isMobile ? 130 : 160} />
              {!isMobile && (
                <span className="text-sm font-normal font-inter">
                  {formatCurrency(Number(productDetails?.productPrice), defaultCurrency)}
                </span>
              )}
            </div>
          </div>
          <OptionsContainer options={productForOptions.options} product={productForOptions} allOptions={allOptions} />
          {isMobile && (
            <span className="text-sm font-normal font-inter">
              {formatCurrency(Number(productDetails?.productPrice), defaultCurrency)}
            </span>
          )}
        </div>
      </div>

      <AddToCartButton
        isCartEnabled={isCartEnabled}
        setIsCartEnabled={setIsCartEnabled}
        currentQuantity={currentQuantity}
        maxQuantity={maxQuantities?.[product.variantId || product.id] || 1}
        setCurrentQuantity={(newQuantity) =>
          setQuantities({ ...quantities, [product.variantId || product.id]: newQuantity })
        }
      />
    </div>
  );
}
